import { render, staticRenderFns } from "./LatestProductModal.vue?vue&type=template&id=53800037"
import script from "./LatestProductModal.vue?vue&type=script&lang=js"
export * from "./LatestProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports